<template lang="pug">
.container.customers
  auto-edit-table(:defines='$defines.customer', unstackable, :data='filtered', layout='list', title='住户信息', :pagesize='30')
    filters-group(:data='customers', :result.sync='filtered', slot='afterTitle')
      .ui.two.columns.stackable.form.grid.filters
        .column
          h4 筛选
          filter-select(:filter='$defines.customer.filters.select', v-model='select')
        .column
          h4 搜索
          filter-search(:filter='$defines.customer.filters.search', :defines='$defines.customer', placeholder='姓名/手机/身份证/地址 等')
</template>

<script>
import { AutoEditTable } from '../components/auto'
import { FiltersGroup, FilterSearch, FilterSelect } from '../components/filters'

export default {
  name: 'customers',
  components: {
    AutoEditTable,
    FilterSearch,
    FilterSelect,
    FiltersGroup,
  },
  computed: {
    customers() {
      return this.$store.state.summary.customers
    },
  },
  data() {
    return {
      filtered: [],
      select: 'checked',
    }
  },
}
</script>



// WEBPACK FOOTER //
// Customers.vue?3402fe6d